import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { editBreakoutRoomsRequested } from 'features/breakout-rooms/actions';

export function* editBreakoutRoomsSaga(action: ReturnType<typeof editBreakoutRoomsRequested>) {
  yield call(SignalingSocket.send, {
    event: 'editBreakoutRooms',
    data: action.payload,
  });
}
